import { brand } from '@helpers/brand';
import fonts from '@helpers/fonts';
import { baseGrid } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import { contentStyles, h1, h3, h5, paragraphLarge } from '@helpers/typography';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) ``;
const Inner = styled.div `
  ${baseGrid}
  row-gap: 16px;
`;
const ContentWrapper = styled.div `
  grid-column: 1 / span 12;
  text-align: center;

  @media ${from(Device.TabletLarge)} {
    grid-row: 1;
    grid-column: 1 / span 6;
    padding-right: 36px;
    text-align: left;
  }
`;
const MainContentWrapper = styled.div `
  grid-column: 1 / span 12;

  @media ${from(Device.TabletLarge)} {
    grid-row: 2;
    grid-column: 1 / span 6;
    padding-right: 36px;
    text-align: left;
  }
`;
const Tag = styled.div `
  ${fonts.montserrat.bold};
  display: inline-block;
  background-color: ${brand.green.tea};
  border: 2px solid ${brand.green.mid};
  font-size: 12px;
  line-height: 20px;
  border-radius: 2000000px;
  padding: 4px 15px;
  margin-bottom: 10px;

  @media ${from(Device.TabletLarge)} {
    font-size: 14px;
    padding: 8px 15px;
    margin-bottom: 15px;
  }
`;
const Title = styled.h1 `
  ${h1}
  margin-bottom: 5px;

  @media ${until(Device.Tablet)} {
    font-size: 24px;
    line-height: 32px;
  }
`;
const Job = styled.p `
  ${fonts.montserrat.medium};
  font-size: 16px;
  line-height: 26px;
  margin-bottom: 15px;

  @media ${from(Device.TabletLarge)} {
    font-size: 28px;
    line-height: 36px;
  }
`;
const LocationArea = styled.div `
  display: inline-flex;
  align-items: center;
  margin-bottom: 10px;

  @media ${from(Device.TabletLarge)} {
    margin-bottom: 20px;
  }

  svg {
    height: 20px;

    @media ${from(Device.TabletLarge)} {
      height: 32px;
    }
  }
`;
const LocationTitle = styled.p `
  ${paragraphLarge};
  padding-left: 5px;
  margin-bottom: 0;
`;
const Content = styled.div `
  ${contentStyles}
  margin-bottom: 35px;

  &:last-child {
    margin-bottom: 0;
  }

  @media ${from(Device.TabletLarge)} {
    li {
      font-size: 22px;
      line-height: 38px;
    }
  }
`;
const MediaWrapper = styled.div `
  grid-column: 1 / span 12;
  padding-bottom: 32px;

  @media ${from(Device.TabletLarge)} {
    grid-row: 1 / span 2;
    grid-column: 8 / span 5;
    padding-bottom: 0;
  }

  @media ${from(Device.Desktop)} {
    grid-column: 9 / span 4;
  }
`;
const MediaInner = styled.div `
  @media ${from(Device.TabletLarge)} {
    max-width: 424px;
    margin-left: auto;
    position: sticky;
    top: 230px;
  }
`;
const MediaAssetWrapper = styled.div `
  position: relative;
  height: 0px;
  padding-bottom: ${({ aspectRatio }) => aspectRatio}%;
`;
const Image = styled.img `
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  border-radius: 16px;
  height: 100%;
  overflow: hidden;
  width: 100%;
  object-fit: cover;
`;
const ContentSection = styled.div `
  margin-bottom: 40px;

  &:last-child {
    margin-bottom: 0;
  }
`;
const TitleArea = styled.div `
  display: inline-flex;
  align-items: center;
  margin-bottom: 20px;
`;
const Icon = styled.img `
  display: block;
  height: 24px;
  margin-right: 10px;
  object-fit: contain;
  object-position: center;
  width: 24px;

  @media ${from(Device.Tablet)} {
    height: 32px;
    width: 32px;
  }
`;
const Details = styled.div `
  margin-top: 20px;
`;
const DetailsTitle = styled.h4 `
  ${h5};
  ${fonts.montserrat.bold};
  margin-bottom: 10px;

  @media ${until(Device.Tablet)} {
    font-size: 20px;
  }
`;
const ExpertiseList = styled.ul `
  padding-left: 12px;
  margin-bottom: 15px;

  @media ${from(Device.TabletLarge)} {
    margin-bottom: 25px;
  }
`;
const ExpertiseItem = styled.li `
  list-style: disc;
  margin-bottom: 10px;

  ${paragraphLarge};
  color: ${brand.black};

  @media ${until(Device.Tablet)} {
    font-size: 16px;
    line-height: 28px;
  }

  @media ${from(Device.Tablet)} {
    line-height: 32px;
  }
`;
const ExpertiseLink = styled.a `
  color: ${brand.black};
`;
const LinkedInArea = styled.div `
  display: inline-flex;
  align-items: center;

  svg {
    height: 20px;

    @media ${from(Device.TabletLarge)} {
      height: 24px;
    }
  }
`;
const LinkedInTitle = styled.a `
  color: ${brand.black};
  font-size: 16px;
  line-height: 28px;
  padding-left: 10px;

  @media ${from(Device.TabletLarge)} {
    font-size: 20px;
    line-height: 28px;
  }
`;
const ContentTitle = styled.h3 `
  ${h3};
  margin-bottom: 0;
`;
const TestimonailSection = styled.div ``;
const SubContent = styled.div `
  grid-column: 1 / span 12;

  @media ${from(Device.TabletLarge)} {
    grid-column: 1 / span 6;
  }
`;
const PeopleArticleHeaderStyles = {
    Container,
    Content,
    ContentSection,
    ContentTitle,
    ContentWrapper,
    Details,
    DetailsTitle,
    ExpertiseItem,
    ExpertiseLink,
    ExpertiseList,
    Icon,
    Image,
    Inner,
    Job,
    LinkedInArea,
    LinkedInTitle,
    LocationArea,
    LocationTitle,
    MainContentWrapper,
    MediaAssetWrapper,
    MediaInner,
    MediaWrapper,
    SubContent,
    Tag,
    TestimonailSection,
    Title,
    TitleArea,
};
export default PeopleArticleHeaderStyles;
